import { IntegrationCommunicator } from ".";

export interface Capabilities {
	type: "mobile" | "desktop";
	platform: "ios" | "android" | "windows" | "osx" | "linux";
	pushNotifications: boolean;
	pushNotificationToken: string;
	// @deprecated
	touchID: boolean;
	// @deprecated
	deviceID?: string;
	// @deprecated
	deviceModel?: string;
}

const capableUserAgents = ["Tareso/Mobile", "Tareso/Desktop"];

let capabilities: Capabilities = {
	type: null,
	platform: null,
	pushNotifications: false,
	pushNotificationToken: null,
	touchID: false
};
let capabilitiesLoaded = false;

const requestCapabilities = () =>
	new Promise(resolve => {
		let timer: number = null;

		IntegrationCommunicator.on("capabilities", data => {
			capabilities = data.payload as Capabilities;
			capabilitiesLoaded = true;

			clearTimeout(timer);
			resolve();
		});

		IntegrationCommunicator.request("getCapabilities");

		timer = setTimeout(() => {
			capabilitiesLoaded = true;

			console.warn(
				"Application environment does not provide any capabilities!"
			);

			resolve();
		}, 2500);
	});

export const requestNotificationToken = () =>
	new Promise<string>(resolve => {
		let timer: number = null;

		IntegrationCommunicator.on("notificationToken", data => {
			resolve((data.payload as any).token);

			clearTimeout(timer);
			resolve();
		});

		IntegrationCommunicator.request("getNotificationToken");

		timer = setTimeout(() => {
			console.warn(
				"Application environment does not provide a notification token!"
			);

			resolve();
		}, 2500);
	});

const requestCapabilitiesFromEnvironment = async () => {
	const userAgent = navigator.userAgent;
	let capableEnvironment = false;

	capableUserAgents.forEach(ua => {
		if (userAgent.indexOf(ua) > -1) {
			capableEnvironment = true;
		}
	});

	if (capableEnvironment) {
		const [uaType, deviceInfo, osInfo] = navigator.userAgent.split(" ");
		const [brand, phoneModel] = deviceInfo.split(":");
		const [osName, osVersion] = osInfo.split(":");

		capabilities.type = uaType.includes("Mobile") ? "mobile" : "desktop";

		switch (osName.toLowerCase()) {
			case "android":
				capabilities.platform = "android";
				break;

			case "ios":
			case "ipados":
				capabilities.platform = "ios";
				break;
		}
	} else {
		capabilitiesLoaded = true;
	}
};

export const getCapabilities = async () => {
	if (capabilitiesLoaded) {
		return capabilities;
	} else {
		await requestCapabilitiesFromEnvironment();

		return capabilities;
	}
};
